import React from 'react'
import classNames from 'classnames'

export default class Badge extends React.PureComponent {
  static defaultProps = {
    onClick: () => {},
    style: {},
  }

  render() {
    const {
      active,
      children,
      className,
      style,
      onClick,
      paddingClass = 'padding-smaller',
    } = this.props

    return (
      <div
        onClick={onClick}
        className={classNames(
          'center-text font-weight-bold font-size-smaller radius-normal uppercase ',
          paddingClass,
          {
            'background-primary shade-100-important': active,
            'background-shade-50 shade-10': !active,
          },
          className
        )}
        style={{
          ...style,
        }}
      >
        {children}
      </div>
    )
  }
}
